import React from 'react';
import { View } from 'react-native';
import CornerTopLeftSvg from '@assets/images/svg/doc-capture/corner-top-left.svg';

export interface CornerTopLeftIconProps {
    size?: number;
}

export function CornerTopLeftIcon({ size = 71 }: CornerTopLeftIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <CornerTopLeftSvg width={size} height={size} />
        </View>
    );
}

export default CornerTopLeftIcon;

